<template>
<div class="container-fluid" >

 <div class="card border-success">

  
   <h4 class="card-header text-white bg-primary"><i class="fas fa-user-tag mr-2" aria-hidden="true"></i>VENDITE SHOPPING ASSISTANT</h4>
  

 <div  class="card-body"> 
  <div class="row">
   <div class="col-2"> 

  <div class="card border-info" >
  <div class="card-header bg-info"><strong>PARAMETRI DI RICERCA</strong></div>
  <div class="card-body text-dark">

  <form name="filter" v-on:submit.prevent="submit()">
      
       <div class="form-group">

        <label for="date_doc"><strong>da Data vendita </strong></label>
        <input  required v-model="data1" type="date" class="form-control" placeholder="" >        
        <div class="form-group">
          <label for="date_doc"><strong>a Data vendita </strong></label>
          <input  required v-model="data2" type="date" class="form-control" placeholder="" >        
        </div>
         
        <store-select v-bind:props="store"  @update="setStoreId"></store-select> 
        
      
      <div class="col-auto"> 
        
       <!--   
       <span><strong>Tipo raggruppamento</strong></span>  
       <div  v-for="(item,index) in grouping" :key="index">  
        <div class="form-check">
          <input type="radio" class="form-check-input" :id="'group_by_' + index" :value="index" v-model="group_by">
          <label class="form-check-label"  :for="'group_by_' + index">{{item.group_by}}</label>
        </div>
       </div>
        -->

      </div>
  
      </div>

 <!--   
  </div>  -->
<div class="card-footer bg-transparent border-info"> 
   <button type="submit"  class="btn btn-primary float-right">
    <i class="far fa-play-circle mr-2"></i>
    ESEGUI
      <span v-if="spinner" class="spinner-border spinner-border-sm ml-3" role="status" aria-hidden="true"></span>
     </button>           
    <!-- 
    <button @click="items=[],row_total=[]" type="button"   class="btn btn-outline-secondary ">
       <i class="fas fa-redo-alt mr-2"></i>
      
        RESET
    </button>   
  -->
</div>
  </form>
  </div>
  </div>
   </div>

 <div class="col-10">

    <alert-box class="mt-2" @close="msg.title=''" v-bind:msg="msg"  ></alert-box>
  <div class="table-wrapper-scroll-y my-custom-scrollbar">

  <table id='my-table' class="table table table-hover table-striped mb-0">
    <thead >
      <tr class="table-primary">
        <th scope="col">ASSISTANT CODE</th>
        <!--<th scope="col">Anno</th>-->
        
        <th scope="col">SEDE</th>
        <th class="text-right" scope="col">QUANTITA' IN FASCIA ORARIA (AM)</th>        
        <th class="text-right" scope="col">QUANTITA' IN FASCIA ORARIA (PM)</th>   
        <th class="text-right" scope="col">TOTALE</th>                
        <th class="text-right" scope="col">TOTALE € IN FASCIA ORARIA (AM)</th>        
        <th class="text-right" scope="col">TOTALE € IN FASCIA ORARIA (PM)</th>        
        <th class="text-right" scope="col">TOTALE (€)</th>
                           
      </tr>
    </thead>
    <tbody>
      <tr :style="{fontSize: '15px',fontWeight: 'bold' }"   data-toggle="tooltip" title="" class="pointer" v-for="(item, index) in items" :key="index">
        <td >{{item.code}} </td>        
        
        <!--<td >{{item.season_year}}</td> -->       
        
     
        <td >{{item.store}}</td>    
        <td class="text-right">{{fmt2(item.col1)}} </td>    
        <td class="text-right">{{fmt2(item.col2)}} </td>    
        <td class="text-right">{{fmt2(item.total1)}} </td>    

        <td class="text-right">{{fmt1(item.col3)}} </td>        
        <td class="text-right">{{fmt1(item.col4)}}</td>
        <td class="text-right">{{fmt1(item.total2)}} </td>    
        
       
      </tr> 
    </tbody>


    <tfoot>
       <!--
       <tr  :style="{backgroundColor: item.row_type == 2 ? '#FFFFE0':'white', color: item.row_type ==  2 ? 'blue' : 'black',fontSize: item.row_type == 2 ? '20px':'15px',fontWeight:item.row_type == 2 ? 'bold':'normal' }"  data-toggle="tooltip" title="" class="pointer" v-for="(item, index) in row_total" :key="index"> 
        <td>Totale</td>
        <td></td>
        
        <td></td>
        
        
        <td class="text-right">{{fmt2(item.qty)}} </td>        
        <td class="text-right">{{fmt1(item.value)}}</td>
                
        
            
               
        </tr>   
      -->
    </tfoot>    

  </table>

</div>
  
 </div>    
  </div> 
<button :disabled="items.length==0 || spinner_pdf == true" @click="pdf()" type="button"   class="btn btn-success mt-2 ml-3 mb-3 float-right">

<i class="fas fa-file-export mr-2"></i>
      ESPORTA PDF
      <span v-if="spinner_pdf" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
</button>  




 </div>

 </div>
 

</div>


</template>
<script>
import api               from "@/api";
import { mapGetters }    from 'vuex';
import alertBox          from '@/components/common/AlertBox.vue';
import fmt               from '@/components/mixins/fmt.js'


//import yearSelect        from './../../components/common/YearSelect.vue'


import storeSelect       from '@/components/common/StoreSelect_1.vue'
import jsPDF             from 'jspdf';
//import 'jspdf-autotable'
import autoTable from 'jspdf-autotable'

export default {
  mixins: [fmt],
  components: {alertBox,storeSelect},
  data() {
    return {
      
      store             : 
      {
        Id            : 0,
        isActive      : true,
       
        optionBase    : false,
        required      : true
      },
     
      
     
      
     

      data1           : null,
      data2           : null,
     
      alert           : false, 
      spinner         : false,
      spinner_pdf     : false,
      msg             : {

        title     : '',
        body      : '',
        type      : 0

      },
      
      items           : [],
      row_total       : [],
     
      
      
    };
  },

  computed :{
    ...mapGetters(['company']),
   
  },
  directives: {
    focus: {
      // directive definition

      inserted : function(el) 
      {
        //el.focus();
      }

    }
  },
  mounted: function() {},
  created: function() {

    //this.getGrouping()
  },
  methods: {


   header_pdf()
   {
      var obj = {}

      /*
      var season_year_select = document.getElementById('season_year')
      var season_year = season_year_select.options[season_year_select.selectedIndex].text;
      obj.season_year = season_year
    
      */

     
      
      obj.store = '( Tutte le Sedi )'
      if(this.store.Id > 0)
      {
        var store_select = document.getElementById('store_select')
        var store = store_select.options[store_select.selectedIndex].text;
        obj.store = '( ' + store + ' )'
      }


      /*
      var options = $(':checkbox:checked').map(function() 
      {
        return [ $(this).next().text() ];
      }).get();
      var option = ''
      options.forEach(item=>{
      
        option = option + item + ' '
      })
      obj.options = option + season_year
      */
      
      return obj
    


   }, 

   async  pdf()
    {

      
      const addFooters = doc => {
      const pageCount = doc.internal.getNumberOfPages()
      doc.setFont('helvetica', 'italic')
      doc.setFontSize(8)
      for (var i = 1; i <= pageCount; i++) {
        doc.setPage(i)

        doc.text('Pag. ' + String(i) + ' di ' + String(pageCount), 50,200, {
        align: 'center'})
      }
      }
       
       this.spinner_pdf = true


       const doc = new jsPDF(
         
         {
         
       orientation: "landscape",

        
      })
      doc.setFontSize(8)
      var d = new Date();
      var n = d.toLocaleDateString();
      var t = d.toLocaleTimeString();

      doc.text("VENDITE SHOPPING ASSISTANT del  " + n + ' ' + t , 15, 10);
      doc.setFontSize(8)
      const d1 = new Date(this.data1)
      const d2 = new Date(this.data2)
      doc.text("PERIODO dal  " + d1.toLocaleDateString() + ' al ' + d2.toLocaleDateString()  +  ' ' + this.header_pdf().store , 15, 15);
      
      
      doc.autoTable(
      
    
       { html: '#my-table',
       margin       : {top:20},
       showFoot: 'lastPage',
       footStyles:{fontStyle:'bold',fillColor:'white',textColor:'black',fontSize:7,cellWidth: 'wrap',},
       columnStyles : {
          2:{
                halign:'right'
          },
          3:{
                halign:'right'
          },
          4:{
                halign:'right'
          },
          5:{
                halign:'right'
          },
          6:{
                halign:'right'
          },
          7:{
                halign:'right'
          },
        },
          didParseCell: function(data) {

            
              
              
              data.cell.styles.fontStyle = 'bold';
              data.cell.styles.fontSize = 6
              //console.log(data.row.cells[0].text)

            
          


          
          }, 



       styles : {
          font       : 'helvetica',
          //rowHeight  : 5,  
          fontSize   : 6,
          }
        })
      
     
     addFooters(doc) 
    //var string = doc.output('datauristring');
    //doc.output('dataurlnewwindow');
    var fileName = 'Report'
    window.open(doc.output('bloburl', { filename: fileName }), '_blank');
    //console.log(string)
    this.spinner_pdf = false
    //doc.save('sellOut_' + Date.now()  + '.pdf', {returnPromise:true}).then(this.spinner_pdf=false);
      
     
    },
 
      
    
    setStoreId(Id)
    {
      this.store.Id = Id
      
    },
    
    submit() 
    {
     this.getData()
    },  
    
  
    async getData() {
      
      this.row_total = []
      this.items = []
      
      
      
      this.msg.title = ''
      
      const sp = {'sp' : 'spShoppingAssistantSales'} 
      const data  = {

          'companyId':this.company.Id,'data1':this.data1,'data2':this.data2,'storeId':this.store.Id
      }
      
      const json  = Object.assign(data, sp)
      this.spinner = true


      await api.post(json).then(res => {
         
          if(res.status==200)
            {
              
              this.items = res.data.recordsets[0]
              
                              
            if(this.items.length==0)
              {
                
                this.msg.title = 'ATTENZIONE '
                this.msg.body  = 'DATI INESISTENTI.'
                this.msg.type  = 1
              }

            }
            else if (res.status==500)
            {
              

              this.msg.title = 'ATTENZIONE '
              this.msg.body  = res.data
              this.msg.type  = 1
              
            }
          
          else
          {

            

            this.msg.title = 'ATTENZIONE '
            this.msg.body  = res
            this.msg.type  = 1
                        

          }
      }).catch(err=>{
        
           
            this.msg.title = 'ATTENZIONE '
            this.msg.body  = err.message
            this.msg.type  = 1
        

      }).finally(() => {
          this.spinner = false
        });
      


    }
  }
};
</script>
<style scoped>


.my-custom-scrollbar {
position   : relative;
height     : 500px;
overflow   : auto;
}
.pointer:hover
{
  background-color: blue;
  color: white;
  cursor: pointer;
}


.table thead  tr:nth-child(1) th
 {

    font-family  : 'Roboto Condensed';
    font-size    : 16px;
    color       : rgb(16, 16, 15) !important;
    background  : #a9cbe2;
    
    
    position     : sticky;
    top          : 0;
    z-index      : 10;

 }

.table tfoot  tr:nth-child(1) td
 {

    font-family  : 'Roboto Condensed';
    font-size    : 20px;
    background   : whitesmoke;
    color        : black;   
    position     : sticky;
    bottom       : 0;
    z-index      : 10;
    height       : 50px;

 }

.table-wrapper-scroll-y {
display: block;
}
.table th:first-child
{
  border-radius : 0 0 0 10px;
}
.table th:last-child
{
  border-radius : 0 10px 0 0;  
}



h4 {
  font-family  : 'Roboto Condensed';
  font-size    : 20px;
}
.form-check-label{
  cursor:pointer
}
</style>